'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCrop75 = function MdCrop75(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 25v-10h-23.2v10h23.2z m0-13.4q1.4 0 2.4 1.1t1 2.3v10q0 1.3-1 2.3t-2.4 1.1h-23.2q-1.4 0-2.4-1.1t-1-2.3v-10q0-1.3 1-2.3t2.4-1.1h23.2z' })
        )
    );
};

exports.default = MdCrop75;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/crop-7-5.js
// module id = 892
// module chunks = 36573943044255 79611799117203 213534597649335